import { SVGProps } from "react";
import * as React from "react";

import { createSvgIcon } from "@mui/material";

export const PlayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 23 23"
    fill={"none"}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.2158 21.9948H11.2162C16.8636 21.9906 21.4341 17.3787 21.4383 11.6966V11.6962C21.4383 6.01237 16.865 1.39768 11.2158 1.39768C5.56665 1.39768 0.993406 6.01237 0.993406 11.6962C0.993406 17.3801 5.56665 21.9948 11.2158 21.9948ZM0.5 11.6962C0.5 5.72576 5.30121 0.892578 11.2158 0.892578C17.1305 0.892578 21.9317 5.72576 21.9317 11.6962C21.9317 17.6667 17.1305 22.4999 11.2158 22.4999C5.30121 22.4999 0.5 17.6667 0.5 11.6962Z"
      fill={props.fill}
      stroke={props.stroke}
    />
    <path
      d="M9.83982 14.6923L9.83981 14.6922L9.83491 14.695C9.49626 14.887 9.06641 14.6442 9.06641 14.2369V9.15328C9.06641 8.74561 9.49651 8.50314 9.83478 8.69505L9.83476 8.69507L9.83982 8.69787L14.4415 11.2387C14.7922 11.439 14.7922 11.9511 14.4416 12.1515L9.83982 14.6923Z"
      fill={props.fill}
      stroke={props.stroke}
    />
  </svg>
);
